<template>
  <div
    class="resource-thumbnail"
    :style="{ 'background-image': hasThumbnail ? '' : `url(${fallbackUrl})` }"
  >
    <img
      alt="thumbnail"
      :class="['resource-thumbnail-image', { loaded: hasThumbnail }]"
      :src="thumbUrl"
      @load="handleLoad"
      @error="handleError"
    />
    <div v-if="$slots.default" class="resource-thumbnail-action-header">
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    thumbUrl: {
      type: String,
      default: undefined,
    },
    fallbackUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const imageLoaded = ref(false);
    const imageError = ref(false);

    const hasThumbnail = computed(() => imageLoaded.value && !imageError.value && !!props.thumbUrl);

    const handleLoad = () => {
      imageLoaded.value = true;
      imageError.value = false;
    };

    const handleError = () => {
      imageError.value = true;
    };

    return {
      imageLoaded,
      imageError,
      hasThumbnail,
      handleLoad,
      handleError,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/lib-shared/src/assets/scss/truncate-text';

.resource-thumbnail {
  background: transparent no-repeat top center / cover;
  height: 180px;
  transition: background 0.3s ease-in-out 0.1s;
  position: relative;
  z-index: 0;

  &-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    opacity: 0;
    transition:
      opacity 0.6s ease-in-out,
      display 0.2s ease-in-out;
    z-index: -1;
    position: absolute;

    &.loaded {
      opacity: 1;
    }
  }

  &-action-header {
    display: flex;
    justify-content: space-between;

    & > * {
      &:last-child {
        margin: var(--spacing-50) var(--spacing-50) 0 auto;
      }
    }
  }
}
</style>
